/* eslint-disable @next/next/no-img-element */
import useCommon from '@utils/hooks/common';
import {Form, Skeleton as AntSkeleton} from 'antd';
import {useState} from 'react';
import useRequest from '@utils/hooks/useRequestCustom';
import authApi from '@utils/api/auth.api';
import styles from './styles';
import {env} from 'next-runtime-env';
import {useRouter} from 'next/router';
import {isTelegramMiniApp} from '@components/layout';
import TelegramContent from '../TelegramContent';
import WalletConnectContent from '../WalletConnectContent';
import EmailContent from '../EmailContent';

interface Network {
  network: string;
  token: string;
  fee: string;
  decimalUnit: number;
  contractAddress: `0x${string}`;
  networkTokenId: any;
}

interface BalanceInfo {
  decimals: number;
  formatted: string;
  symbol: string;
  value: bigint;
}

interface Balances {
  [key: string]: BalanceInfo;
}

const ERC20_ADDRESS = '0xdAC17F958D2ee523a2206206994597C13D831ec7';

const MOCK_NETWORKS = [
  {
    network: 'ERC20',
    token: 'USDT',
    fee: '0',
    decimalUnit: 18,
    contractAddress: '0x55d398326f99059ff775485246999027b3197955' as `0x${string}`,
    networkTokenId: 'USDT_BSC',
  },
  {
    network: 'ERC20',
    token: 'USDT',
    fee: '0',
    decimalUnit: 6,
    contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7' as `0x${string}`,
    networkTokenId: 'USDT_ETH',
  },
  {
    network: 'TRC20',
    token: 'USDT',
    fee: '0',
    decimalUnit: 6,
    contractAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t' as any,
    networkTokenId: 'USDT_TRX',
  },
];

const TOKEN_TO_CHAIN_ID = {
  USDT_BSC: 56, // Binance Smart Chain
  USDT_ETH: 1, // ETH
  // add other mappings as needed
};

export const DEFAULT_NETWORK_TOKEN_ID = 'USDT_ETH';
const TON_DEFAULT_TOKEN = 'USDT_TON';

const FORM_INITIAL_VALUES = {blockchain: 'usdt'};

const DepositTab = () => {
  const {classes, t, user, system} = useCommon({
    withTranslation: ['deposit_withdraw'],
    withStyles: styles,
    observers: ['user', 'system'],
  });

  const router = useRouter();

  const [form] = Form.useForm();

  const [regType, setRegType] = useState<'WALLET' | 'METAMASK' | 'EMAIL'>(null);

  const isTg = isTelegramMiniApp;
  // const isTg = true;

  const {data: depositInfo, loading: loadingDepositInfo} = useRequest(authApi.getDepositInfo, {
    onSuccess: result => {
      setRegType(result?.registrationType);
    },
    onError: err => {
      // console.log(err?.response?.)
      // console.log(err?.response?.status)
      switch (err?.response?.status) {
        case 401:
          localStorage.removeItem('playerToken');
          window.location.reload();
          break;
      }
    },
  });

  const renderContent = () => {
    if (isTg) return <TelegramContent />;
    if (regType === 'WALLET' || regType === 'METAMASK') return <WalletConnectContent />;
    if (regType === 'EMAIL') return <EmailContent />;
  };

  if (loadingDepositInfo || !regType) return <AntSkeleton paragraph={{rows: 5}} active />;

  return <>{renderContent()}</>;
};

export default DepositTab;
